<script setup>
import {computed} from 'vue'
import {useProductStore} from '@js/store/ProductStore.js'
import {Link} from "@inertiajs/vue3";
import IconInfo from "@js/components/Icons/IconInfo.vue";

const productStore = useProductStore()

// Берём сгруппированные хар-ки; если бэк не отдал — fallback: пусто
const characteristics_grouped = computed(() =>
    productStore.characteristics_grouped ?? []
)

const isTech = (row) => row?.is_tech_characteristic
const general = computed(() => characteristics_grouped.value.filter(r => !isTech(r)))
const technical = computed(() => characteristics_grouped.value.filter(r => isTech(r)))
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div class="relative">
            <div class="px-4 sm:px-0 mb-2">
                <h2 class="text-base/7 font-semibold text-gray-900">
                    Характеристики товара
                </h2>
            </div>
            <div class="border-t border-gray-200">
                <dl v-if="general.length">
                    <div v-for="row in general" :key="row.key || row.type_id"
                         class="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 odd:bg-white even:bg-gray-50 md:hover:bg-gray-100 transition">
                        <dt class="text-sm font-medium text-gray-900">
                            {{ row.title || row.title_en || 'Характеристика' }}
                        </dt>
                        <dd class="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0 md:text-right">
                            <template v-if="Array.isArray(row.values)">
                                <Link v-for="(v, i) in row.values" :key="i"
                                      :href="route('catalog', {
                                  category_title:productStore.product.category.slug,
                                  characteristics: JSON.stringify([{ type_id: row.type_id, values: [String(v).trim()] }]),
                                  })"
                                      class="md:hover:text-navHoverColor transition">
                                    {{ v }}<span v-if="i < row.values.length - 1"> / </span>
                                </Link>
                            </template>
                            <template v-else>
                                {{ row.values }}
                            </template>
                        </dd>
                    </div>
                </dl>

                <div v-else class="p-4 text-sm text-gray-500">
                    Характеристики не указаны.
                </div>
            </div>
        </div>
        <div class="relative">
            <div class="px-4 sm:px-0 mb-2">
                <h2 class="text-base/7 font-semibold text-gray-900">
                    Технические характеристики
                </h2>
            </div>
            <div class="border-t border-gray-200">

                <dl v-if="technical.length">
                    <div v-for="row in technical" :key="row.key || row.type_id"
                         class="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 odd:bg-white even:bg-gray-50 md:hover:bg-gray-100 transition">
                        <dt class="text-sm font-medium text-gray-900">
                            {{ row.title || row.title_en || 'Характеристика' }}
                        </dt>
                        <dd class="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0 md:text-right">
                            <template v-if="Array.isArray(row.values)">
                                <Link v-for="(v, i) in row.values" :key="i"
                                      :href="route('catalog', {
                                  category_title:productStore.product.category.slug,
                                  characteristics: JSON.stringify([{ type_id: row.type_id, values: [String(v).trim()] }]),
                                  })"
                                      class="md:hover:text-navHoverColor transition">
                                    {{ v }}<span v-if="i < row.values.length - 1"> / </span>
                                </Link>
                            </template>
                            <template v-else>
                                {{ row.values }}
                            </template>
                        </dd>
                    </div>
                </dl>

                <div v-else class="p-4 text-sm text-gray-500">
                    Характеристики не указаны.
                </div>
            </div>
        </div>
        <div>
            <div class="flex flex-col gap-2 text-xs leading-4">
                <p class="flex items-center gap-2 text-sm font-medium">
                    <IconInfo class="w-5 h-5"/>
                    Масса и расчёт цены.
                </p>
                <p>
                    Указанные теоретические массы приведены для ориентировочных расчётов. При продаже по цене за тонну
                    окончательная стоимость может определяться по фактической массе партии/отгрузки (по результатам
                    взвешивания).
                </p>
                <p>
                    При цене за метр — расчёт ведётся из теоретической массы согласно стандарту, возможна
                    корректировка с учётом фактических допусков.
                </p>
                <p>
                    Марка стали, класс, стандарт (ГОСТ/ТУ), длина (мерная/немерная), дата выпуска и сертификация
                    указываются в сопроводительных документах и/или на бирке упаковки. Для уточнения характеристик
                    конкретной партии обращайтесь к менеджеру.
                </p>
            </div>
        </div>
    </div>
</template>
